<template>
  <div>
    <h4 class="text-uppercase mb-1">{{ $t("sender_address") }}</h4>
    <address-section
      :name="sender.name"
      :lastname="sender.lastname"
      :address="senderLocation.address"
      :zip="senderLocation.zip"
      :city="senderLocation.city.name"
    />

    <h4 class="text-uppercase mt-5 mb-1">{{ $t("recipient_address") }}</h4>
    <address-section
      :name="receiver.name"
      :lastname="receiver.lastname"
      :address="receiverLocation.address"
      :zip="receiverLocation.zip"
      :city="receiverLocation.city.name"
    />
  </div>
</template>

<script>
import AddressSection from "./AddressSection.vue";

export default {
  name: "SenderReceiverInfo",
  components: {
    AddressSection,
  },
  props: {
    sender: {
      type: Object,
      required: true,
    },
    senderLocation: {
      type: Object,
      required: true,
    },
    receiver: {
      type: Object,
      required: true,
    },
    receiverLocation: {
      type: Object,
      required: true,
    },
  },
};
</script>
